<template>
    <v-img :src="imageSrc"
           min-width="50"
           :max-height="height"
           lazy-src="/images/default.jpg"
           :alt="altText"
           :height="fixedHeight"
           :width="fixedWidth"
           contain></v-img>
</template>

<script>
    export default {
        props: {
            PHID: {
                type: String,
                required: false,
                value: '0'
            },
            height: {
                default: '355'
            },
            fixedHeight: {
                required: false,
                value: '0'
            },
            fixedWidth: {
                required: false,
                value: '0'
            }
        },
        computed: {

            imageSrc: function () {
                if (this.PHID && (this.PHID != undefined || this.PHID != 'Undefined'))
                    return this.$store.state.URL_IMAGES.replace("{0}", this.PHID);
                else
                    return '/images/default.jpg';
            },
            altText: function () {
                let parliamentarian = this.$store.getters.GET_PARLIAMENTARIANS.find(p => p.PHID === this.PHID);
                let alt = "Photograph of ";
                if (parliamentarian){
                    alt += parliamentarian.DisplayName;
                } else{
                    alt += "Parliamentarian";
                }
                return alt;
            }
        }
    }
</script>
